"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var ToolsDetailController = /*#__PURE__*/function (_PageController) {
  _inherits(ToolsDetailController, _PageController);
  function ToolsDetailController() {
    var _this2;
    _classCallCheck(this, ToolsDetailController);
    _this2 = _callSuper(this, ToolsDetailController);
    var fixedCover = new FixedCover('fixedCover');
    _this2.stringUtils = new StringUtils();
    _this2.numberUtils = new NumberUtils();
    _this2.init();
    _this2.initDownload();
    var storeInit = new Store();
    if (_this2.platform.isPhone()) {
      _this2.initAnchorScroll(40);
    } else {
      _this2.initAnchorScroll(100);
    }
    //this.submitCheck();

    // popover plugin
    $('.popover .name-inner').webuiPopover({
      trigger: "hover",
      placement: _this2.platform.isPhone() === false ? 'auto-right' : 'auto',
      title: '',
      style: _this2.platform.isPhone() === false ? 'more-information' : 'more-information-mobile',
      width: _this2.platform.isPhone() === false ? 400 : 250
    });
    return _this2;
  }

  // --------------- DOWNLOAD SECTION -----------------
  _createClass(ToolsDetailController, [{
    key: "initDownload",
    value: function initDownload() {
      this._downloadVersionBasicInfo = $("#download-content .version .basic-info");
      this._downloadVersion = $("#download-content .version");
      this.openFirstVersion();
      this.initClickToVersion();
    }
  }, {
    key: "openFirstVersion",
    value: function openFirstVersion() {
      var version = this._downloadVersion.first();
      var versionSubmenu = this.getDownloadVersionSubmenu(version);
      version.attr("data-active", "true");
      versionSubmenu.slideDown();
    }
  }, {
    key: "initClickToVersion",
    value: function initClickToVersion() {
      var _this3 = this;
      this._downloadVersionBasicInfo.click(function (e) {
        var _this = $(e.currentTarget);
        var version = _this3.getParentDownloadVersion(_this);
        var versionSubmenu = _this3.getDownloadVersionSubmenu(version);
        var versionIsOpen = version.attr("data-active");
        if (versionIsOpen !== "true") {
          version.attr("data-active", "true");
          versionSubmenu.slideDown();
        } else {
          version.attr("data-active", "false");
          versionSubmenu.slideUp();
        }
      });
    }
  }, {
    key: "getParentDownloadVersion",
    value: function getParentDownloadVersion(ele) {
      return ele.parents(".version");
    }
  }, {
    key: "getDownloadVersionSubmenu",
    value: function getDownloadVersionSubmenu(versionEle) {
      return versionEle.find(".version-submenu");
    }

    // --------------- OTHER -----------------
  }, {
    key: "init",
    value: function init() {
      this.clickToBuyScrollButton();
      this.clickToDownloadScrollButton();

      // this.initTestimonialSliderSingle();
    }

    /*initTestimonialSliderSingle() {
        let singleTestimonialSlider = new Swiper('.testimonial-slider-single', {
            direction: 'horizontal',
            loop: true,
            allowSlideNext: false,
            allowSlidePrev: false,
            allowTouchMove: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
         $(".testimonial-slider-single .play-icon").click((e) => {
            let _this = $(e.currentTarget);
             singleTestimonialSlider.autoplay.stop();
        });
    }*/

    // BUTTONs IN COVER IMAGE
  }, {
    key: "clickToBuyScrollButton",
    value: function clickToBuyScrollButton() {
      var _this4 = this;
      $(".buy-button").click(function () {
        NavigationUtils.scrollToElement($("section[data-anchor='buy']"), -_this4.getHeaderHeight());
      });
    }
  }, {
    key: "clickToDownloadScrollButton",
    value:
    // BUTTONs IN COVER IMAGE
    function clickToDownloadScrollButton() {
      var _this5 = this;
      $(".download-button").click(function () {
        NavigationUtils.scrollToElement($("section[data-anchor='download']"), -_this5.getHeaderHeight());
      });
    }
  }]);
  return ToolsDetailController;
}(PageController);